import React from 'react';
import { withTranslation } from 'react-i18next';
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
} from 'reactstrap';
import { DropdownButton } from '../../../UI/DropdownBtn';

const dropdownStyle = { boxSizing: 'border-box' };
const ActionsDropdown = ({ t, options, ...props }) => {
  return (
    <FormGroup>
      <DropdownButton>
        <DropdownToggle caret color="secondary">
          {t('Actions')}
        </DropdownToggle>
        <DropdownMenu>
          {options.map((option, index) => {
            // console.log(option.disabled);
            return (
              <React.Fragment key={index}>
                <DropdownItem
                  style={dropdownStyle}
                  onClick={option.action}
                  disabled={option.disabled}
                >
                  {t(option.label)}
                </DropdownItem>
                {index + 1 < options.length && <DropdownItem divider />}
              </React.Fragment>
            );
          })}
        </DropdownMenu>
      </DropdownButton>
    </FormGroup>
  );
};

export default withTranslation('app')(ActionsDropdown);
